import api from "../components/api";
import { useEffect, useState } from "react";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons';
import { Modal, Button, Spinner } from 'react-bootstrap';

const OrderInProgress = () => {
    const [orders, setOrders] = useState([]); // Changé en tableau vide par défaut
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = () => {
        setLoading(true);
        api.get('/order_in_progress')
            .then(response => {
                // S'assurer que c'est un tableau
                setOrders(response.data.orderInProgress || []);
            })
            .catch(error => console.error("Erreur de récupération : ", error))
            .finally(() => setLoading(false));
    };

    const handleMarkAsDelivered = () => {
        if (!selectedOrder) return;
        
        setActionLoading(true);
        api.get(`/order_delivered/${selectedOrder.id}`)
            .then(() => {
                // MISE À JOUR LOCALE : On retire la commande livrée de la liste
                setOrders(orders.filter(o => o.id !== selectedOrder.id));
                setShowModal(false);
                // Optionnel : alert ou toast de succès
            })
            .catch(error => console.error('Erreur livraison : ', error))
            .finally(() => setActionLoading(false));
    };

    const handleShowModal = (order) => {
        setSelectedOrder(order);
        setShowModal(true);
    };

    // Filtrage des commandes "En cours" pour simplifier le rendu
    const activeOrders = orders.filter(o => o.status === "En cours");

    return (
        <>
            <Header />
            <div className="container mt-5">
                <h1 className="text-center fw-bold mb-4">Commandes En Cours... 👨‍🍳</h1>

                {loading ? (
                    <div className="text-center mt-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3">Chargement des cuisines...</p>
                    </div>
                ) : (
                    <div className="card border-0 shadow-sm rounded-3">
                        <div className="table-responsive" style={{ maxHeight: '500px' }}>
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Client</th>
                                        <th>Menu</th>
                                        <th>Date</th>
                                        <th>Qté</th>
                                        <th>Prix Total</th>
                                        <th>Localisation</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {activeOrders.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="text-center py-5 text-muted">
                                                Aucune commande n'est en préparation actuellement.
                                            </td>
                                        </tr>
                                    ) : (
                                        activeOrders.map((order, orderIdx) => (
                                            order.order_items.map((item, itemIdx) => (
                                                <tr key={`${order.id}-${item.id}`}>
                                                    {/* On n'affiche le numéro et le nom du client que sur la 1ère ligne de la commande */}
                                                    <td className="fw-bold">{itemIdx === 0 ? orderIdx + 1 : ""}</td>
                                                    <td className="fw-semibold">{itemIdx === 0 ? order.user?.name : ""}</td>
                                                    <td>
                                                        <span className="badge bg-light text-dark border me-2">{item.quantity}x</span>
                                                        {item.menu_item?.name}
                                                    </td>
                                                    <td className="small">
                                                        {itemIdx === 0 ? new Date(order.created_at).toLocaleTimeString('fr-FR', {hour: '2-digit', minute:'2-digit'}) : ""}
                                                    </td>
                                                    <td className="text-center">{item.quantity}</td>
                                                    <td className="fw-bold text-success">{itemIdx === 0 ? `${order.total_price} FCFA` : ""}</td>
                                                    <td>
                                                        {itemIdx === 0 && (
                                                            <span className="badge bg-danger">{order.localisation}</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {itemIdx === 0 && (
                                                            <button 
                                                                className="btn btn-success btn-sm shadow-sm" 
                                                                onClick={() => handleShowModal(order)}
                                                                title="Marquer comme livré"
                                                            >
                                                                <FontAwesomeIcon icon={faTruck} className="me-1" /> Livrer
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal de Confirmation */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fw-bold text-success">Confirmation de livraison</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-3 text-success">
                        <FontAwesomeIcon icon={faTruck} size="3x" className="opacity-50" />
                    </div>
                    <p className="fs-5">
                        Confirmez-vous que la commande de <strong>{selectedOrder?.user?.name}</strong> a bien été remise au livreur ?
                    </p>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center">
                    <Button variant="light" className="px-4" onClick={() => setShowModal(false)}>
                        Annuler
                    </Button>
                    <Button 
                        variant="success" 
                        className="px-4"
                        onClick={handleMarkAsDelivered}
                        disabled={actionLoading}
                    >
                        {actionLoading ? <Spinner size="sm" /> : "Oui, Livrée !"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default OrderInProgress;